import { trackDownload } from '../services/api';

// PDF URLs
export const BROCHURE_URLS = {
  college: 'https://customer-assets.emergentagent.com/job_edu-social-design/artifacts/z50ccgfu_EduSocial%20College%20Brochure.pdf',
  mentor: 'https://customer-assets.emergentagent.com/job_edu-social-design/artifacts/zb41nnn8_EduSocial%20Mentor%20Brochure.pdf'
};

/**
 * Handle PDF download with tracking
 * @param {string} documentType - Type of document (brochure, mentor_guide)
 * @param {string} sourcePage - Page where download was initiated (colleges, mentors)
 * @param {string} pdfUrl - URL of the PDF to download
 * @param {string} email - Optional email for tracking
 */
export const handleDownload = async (documentType, sourcePage, pdfUrl, email = null) => {
  try {
    // Track the download
    await trackDownload(documentType, sourcePage, email);
    
    // Open PDF in new tab
    window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    
    return true;
  } catch (error) {
    console.error('Error tracking download:', error);
    // Still open the PDF even if tracking fails
    window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    return false;
  }
};

/**
 * Download College Brochure
 */
export const downloadCollegeBrochure = (email = null) => {
  return handleDownload('brochure', 'colleges', BROCHURE_URLS.college, email);
};

/**
 * Download Mentor Guide
 */
export const downloadMentorGuide = (email = null) => {
  return handleDownload('mentor_guide', 'mentors', BROCHURE_URLS.mentor, email);
};
